<template>
    <svg class="icon__arrow-down" xmlns="http://www.w3.org/2000/svg" width="20.887" height="11.151" viewBox="0 0 20.887 11.151">
        <polyline points="20.534 0.354 10.444 10.444 0.354 0.354" fill="none" stroke="#fff" stroke-miterlimit="10"/>
    </svg>
</template>

<script>
export default {
    name: "icon-arrow-down"
}
</script>